"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import React, { useRef } from "react";
import { Transition, TransitionGroup } from "react-transition-group";
import forceReflow from "../../../utils/forceReflow";
import classNames from "classnames";
import { AnimationDuration } from "../../../styles/Animations";
const getCurrentGap = (node) => {
  if (!node.parentElement || node.parentElement.childElementCount === 1) {
    return "0px";
  }
  const rowGap = window.getComputedStyle(node.parentElement).rowGap;
  const isNumeric = !!parseInt(rowGap, 10);
  if (!isNumeric) {
    return "0px";
  }
  return rowGap;
};
export const Expandable = (_a) => {
  var _b = _a, {
    children,
    className,
    onEnter,
    onEntered,
    onExit,
    expanded,
    element: Element = "div",
    timeout = AnimationDuration.Medium
  } = _b, rest = __objRest(_b, [
    "children",
    "className",
    "onEnter",
    "onEntered",
    "onExit",
    "expanded",
    "element",
    "timeout"
  ]);
  const expandableElementRef = useRef(null);
  return /* @__PURE__ */ React.createElement(TransitionGroup, { component: null, timeout }, expanded && /* @__PURE__ */ React.createElement(
    Transition,
    __spreadValues({
      timeout,
      onEnter: (node, isAppearing) => {
        node.style.height = "0px";
        node.style.setProperty("--expandable-gap-size", getCurrentGap(node));
        forceReflow(node);
        onEnter == null ? void 0 : onEnter(node, isAppearing);
        requestAnimationFrame(() => {
          var _a2;
          node.style.height = `${(_a2 = expandableElementRef.current) == null ? void 0 : _a2.offsetHeight}px`;
        });
      },
      onEntered: (node, isAppearing) => {
        forceReflow(node);
        onEntered == null ? void 0 : onEntered(node, isAppearing);
        requestAnimationFrame(() => {
          node.style.height = "auto";
          node.style.setProperty("--expandable-gap-size", null);
        });
      },
      onExit: (node) => {
        var _a2;
        node.style.height = `${(_a2 = expandableElementRef.current) == null ? void 0 : _a2.offsetHeight}px`;
        node.style.setProperty("--expandable-gap-size", getCurrentGap(node));
        forceReflow(node);
        onExit == null ? void 0 : onExit(node);
        requestAnimationFrame(() => {
          node.style.height = "0px";
        });
      }
    }, rest),
    (status) => /* @__PURE__ */ React.createElement(
      Element,
      {
        className: classNames("kl-expandable", `kl-expandable--${status}`, className, {
          [`${className}--${status}`]: className
        }),
        style: { "--duration": `${timeout}ms` }
      },
      children({ status, expandableElementRef })
    )
  ));
};
